var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "package-info",
      class: { active: _vm.active },
      on: { click: _vm.onClick }
    },
    [
      _c("span", { staticClass: "package-info-title" }, [
        _vm._v(_vm._s(_vm.$t("trade.openapi.package") + " " + _vm.data.type))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "left" }, [
        _vm._v(_vm._s(_vm.$t("trade.openapi.callNum")) + ":")
      ]),
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("trade.openapi.callNumInfo", _vm.data)) +
          "\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("trade.openapi.price") + ":") +
          " " +
          _vm._s(
            _vm.$t("trade.openapi.priceInfo", { price: _vm.data.amount })
          ) +
          "\n    "
      ),
      _c("div", { staticClass: "slot" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }